<script>
	export let realty       = {Description:''};
	export let loading      = false;
</script>
{#if !loading && realty != null}
<div class="selos">
	{#if realty.Promotion02 != null && realty.Promotion02.trim().length > 0}
	<div class="selo selo-tour">
		<i class="fas fa-street-view"></i> Tour Virtual
	</div>
	{/if}

	{#if realty.Promotion03 != null && realty.Promotion03.trim().length > 0}
	<div class="selo selo-tour">
		<i class="fab fa-youtube"></i> Vídeo
	</div>
	{/if}

	{#if realty.Promotion == 'C'}
	<a class="selo selo-clear selo-carencia" href="/carencia#tipo_negociacao={realty.CurrentNegotiationTypeId}">
		<img src="/assets/images/selos/carencia.png" alt="Carência" width="100px" />
	</a>
	{/if}
	
	<!-- 
	{#if realty.Promotion == 'TRINTOU'}
	<a class="selo selo-clear selo-trintou" href="/trintou#tipo_negociacao={realty.CurrentNegotiationTypeId}">
		<img src="/assets/images/selos/trintou.png" alt="Trintou" />
	</a>
	{/if}
	-->

</div>
{/if}